<template>
  <div class="addControlManagement-page">
    <div class="all-content-container">
      <div class="table-content-container">
        <div class="table-title-container">
          <div class="table-title-title">
            <div class="title-back">
              <h4>添加控制设备</h4>
              <p class="backBth" @click="canlan">
                <i class="el-icon-caret-left"></i>
                <span>返回</span>
              </p>
            </div>
          </div>
        </div>
        <div class="table-content">
          <el-form label-position="right" label-width="120px" :model="formLabelAlign" :rules="rules" ref="formLabelAlign">
            <!-- <el-form-item label="设备图片：" style="height: 88px" prop="img">
              <el-upload
                class="avatar-uploader"
                :action="$serverUrl + '/pc/growthCrop/uploadImage'"
                :headers="headers"
                name="file"
                :limit="10"
                :on-exceed="handleExceed"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProgress"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="show"
                  :src="formLabelAlign.imageURL"
                  class="avatar"
                />
                <div class="image1" v-if="!show">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
            </el-form-item> -->

            <el-row>
              <el-col :span="12">
                <el-form-item label="设备名称：" prop="name">
                  <el-input v-model="formLabelAlign.name" maxlength="20" clearable placeholder="请输入设备名称" class="inputW"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="设备编码：" prop="code">
                  <el-input v-model="formLabelAlign.code" maxlength="20" clearable placeholder="请输入设备编码" class="inputW"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- <el-col :span="12">
                <el-form-item label="开关分类：" prop="switchType">
                  <el-select
                    v-model="formLabelAlign.switchType"
                    placeholder="请选择开关分类"
                    class="inputW"
                  >
                    <el-option
                      v-for="item in switchType"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <div class="grid-content bg-purple-dark">
                  <el-form-item label="生产日期：" prop="pdate">
                    <el-date-picker v-model="formLabelAlign.pdate" type="date" placeholder=" 请选择生产日期" class="inputW"></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地址位：">
                  <el-input v-model="formLabelAlign.addressBit" maxlength="20" clearable placeholder="请输入地址位" class="inputW"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="所属分组：" prop="groupId">
                  <el-cascader class="inputW" @change="changeTreeItem" :show-all-levels="false" v-model="formLabelAlign.groupId" :options="departList" :props="optionProps" clearable placeholder="请选择所属分组"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属网关：" prop="gatewayId">
                  <el-select v-model="formLabelAlign.gatewayId" placeholder="请选择所属网关" class="inputW">
                    <el-option v-for="item in getGatewaysList" :key="item.value" :label="item.gatewayName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="模板类型：" prop="modelRuleDeviceId">
                  <el-select v-model="formLabelAlign.modelRuleDeviceId" placeholder="请选择模板类型" class="inputW">
                    <el-option v-for="item in modelRuleDeviceIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="协议类型：" prop="protocolType">
                  <el-select v-model="formLabelAlign.protocolType" placeholder="请选择协议类型" class="inputW">
                    <el-option v-for="item in protocolTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="采集数据间隔：" prop="intervalTime">
                  <el-input-number placeholder="请输入采集数据间隔(秒)" v-model="formLabelAlign.intervalTime" :precision="0" :step="1" :min="0" :max="99999999" size="small" clearable class="inputW"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="采集超时间隔：" prop="collectTimeout">
                  <el-input-number placeholder="请输入采集超时间隔(毫秒)" v-model="formLabelAlign.collectTimeout" :precision="0" :step="1" :min="0" :max="99999999" size="small" clearable class="inputW"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="经度：" prop="longitude">
                  <el-input-number placeholder="请输入经度" v-model="formLabelAlign.longitude" :precision="6" :step="1" :min="-99999999" :max="99999999" size="small" clearable class="inputW"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="纬度：" prop="dimension">
                  <el-input-number placeholder="请输入纬度" v-model="formLabelAlign.dimension" :precision="6" :step="1" :min="-99999999" :max="99999999" size="small" clearable class="inputW"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label-width="260px">
              <el-button @click="canlan()">取 消</el-button>
              <el-button type="primary" @click="submitForm('formLabelAlign')">确 定</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        // 弹框表单验证

        img: [{ required: true, message: "请上传图片", trigger: "blur" }],
        name: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入设备编码", trigger: "blur" }],
        paramType: [
          { required: true, message: "请选择参数类型", trigger: "change" },
        ],
        groupId: [
          { required: true, message: "请选择所属分组", trigger: "change" },
        ],
        gatewayId: [
          { required: true, message: "请选择所属网关", trigger: "change" },
        ],
        modelRuleDeviceId: [
          { required: true, message: "请选择模板类型", trigger: "change" },
        ],
        switchType: [
          { required: true, message: "请选择开关分类", trigger: "change" },
        ],
        protocolType: [
          { required: true, message: "请选择协议类型", trigger: "change" },
        ],
        pdate: [
          { required: true, message: "请选择生产日期", trigger: "change" },
        ],
        intervalTime: [
          { required: true, message: "请输入采集数据间隔", trigger: "blur" },
          {
            pattern: /^[0-9]*$/, //正则
            message: "请输入正确的采集数据间隔",
          },
        ],
        collectTimeout: [
          { required: true, message: "请输入采集超时时间", trigger: "blur" },
          {
            pattern: /^[0-9]*$/, //正则
            message: "请输入正确的采集超时时间",
          },
        ],
      },
      modelRuleDeviceIdList: [],
      getGatewaysList: [],
      headers: {
        // 身份验证
        AUTHORIZATION: sessionStorage.getItem("TOKEN"),
      },
      show: false,
      id: "",
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        expandTrigger: "hover",
      },
      protocolTypeList: [
        //协议类型(0：sdk，1：onvif,2：rtsp，3：gb28181）
        {
          id: 0,
          name: "sdk",
        },
        {
          id: 1,
          name: "onvif",
        },
        {
          id: 2,
          name: "rtsp",
        },
        {
          id: 3,
          name: "gb28181",
        },
      ],
      switchType: [
        //开关类型 0无状态基础开关、1无状态模拟开关、2只读开关 开关基础表也有这个字段（冗余字段 加快效率） 3有状态基础开关、4有状态模拟开关
        {
          id: 0,
          name: "无状态基础开关",
        },
        {
          id: 1,
          name: "无状态模拟开关",
        },
        {
          id: 2,
          name: "只读开关",
        },
        {
          id: 3,
          name: "有状态基础开关",
        },
        {
          id: 4,
          name: "有状态模拟开关",
        },
        {
          id: 5,
          name: "正反转开关",
        },
        {
          id: 6,
          name: "展开收缩开关",
        },
        {
          id: 7,
          name: "下发开关",
        },
      ],
      departList: [],
      modelRuleDeviceIdList: [],
      protocolTypeList: [
        //协议类型(0：sdk，1：onvif,2：rtsp，3：gb28181）mqtt，1：coap,2：ModbusTCP，3：ModbusRTU，4：TCP
        {
          id: 0,
          name: "mqtt",
        },
        {
          id: 1,
          name: "coap",
        },
        {
          id: 2,
          name: "ModbusTCP",
        },
        {
          id: 3,
          name: "ModbusRTU",
        },
        {
          id: 4,
          name: "TCP",
        },
      ],
      options: [
        {
          value: "选项1",
          label: "传感树001",
        },
        {
          value: "选项2",
          label: "传感树002",
        },
        {
          value: "选项3",
          label: "传感树004",
        },
        {
          value: "选项4",
          label: "传感树004",
        },
        {
          value: "选项5",
          label: "传感树005",
        },
      ],
      value: "传感树001",
      name: "",
      formLabelAlign: {
        img: "314",
        imageURL: "",
        gatewayId: "",
        groupId: "",
        modelRuleDeviceId: "",
        protocolType: "",
        code: "",
        image: "",
        addressBit: "",
        switchType: "",
        collectTimeout: "",
        intervalTime: "",
        pdate: "",
        longitude: '',
        dimension: '',
        name: "",
        modelRuleDeviceId: "",
        protocolType: "",
      },
    };
  },
  created() {
    this.getSwitch(this.$route.query.id);
    this.id = this.$route.query.id;
    this.getModelRuleDevices();
    this.getConfigGroupTree();
    this.getGateways();
  },
  methods: {
    submitForm(formName) {
      // 提交表单
      // if (this.formLabelAlign.imageURL == "") {
      //   this.$message.error("请先选择设备图片");
      //   return false;
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    //所属分组id
    changeTreeItem(val) {
      this.formLabelAlign.groupId = val[val.length - 1];
    },
    //查询全部设备类型模板
    getModelRuleDevices() {
      this.$api.system
        .getModelRuleDevices(0)
        .then((res) => {
          if (res.code == 200) {
            this.modelRuleDeviceIdList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询全部通信网关
    getGateways() {
      this.$api.system
        .getGateways()
        .then((res) => {
          if (res.code == 200) {
            this.getGatewaysList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询设备分组树，查询1
    getConfigGroupTree() {
      this.$api.system
        .getConfigGroupTree(
          0, //主键id ，根据具体业务进行判定
        )
        .then((res) => {
          if (res.code == 200) {
            this.departList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询全部设备类型模板
    getModelRuleDevices() {
      this.$api.system
        .getModelRuleDevices()
        .then((res) => {
          if (res.code == 200) {
            this.modelRuleDeviceIdList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 查询控制设备详情
    getSwitch(id) {
      if (id == undefined) {
        return false;
      }
      this.$api.system
        .getSwitch(id)
        .then((res) => {
          if (res.code == 200) {
            this.show = true;
            this.formLabelAlign.code = res.data.code;
            this.formLabelAlign.name = res.data.name;
            this.formLabelAlign.groupId = res.data.groupId;
            this.formLabelAlign.modelRuleDeviceId = res.data.modelRuleDeviceId;
            this.formLabelAlign.protocolType = res.data.protocolType;
            this.formLabelAlign.addressBit = res.data.addressBit;
            this.formLabelAlign.gatewayId = res.data.gatewayId;
            this.formLabelAlign.addressBit = res.data.addressBit;
            this.formLabelAlign.collectTimeout = res.data.collectTimeout;
            this.formLabelAlign.dimension =
              res.data.dimension == null ? "" : res.data.dimension;
            this.formLabelAlign.groupId = res.data.groupId;
            this.formLabelAlign.intervalTime = res.data.intervalTime;
            this.formLabelAlign.longitude =
              res.data.longitude == null ? "" : res.data.longitude;
            this.formLabelAlign.modelRuleDeviceId = res.data.modelRuleDeviceId;
            this.formLabelAlign.paramType = res.data.paramType;
            this.formLabelAlign.pdate = res.data.updateTime;
            this.formLabelAlign.protocolTyp = res.data.protocolTyp;
            this.formLabelAlign.id = res.data.id;
            //this.formLabelAlign.imageURL = res.data.image;
            // this.formLabelAlign.switchType = res.data.switchType;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    canlan() {
      // this.$router.go(-1);
      this.$router.push({
        name: "deviceManagement",
        query: {
          currentShow: "second",
          currentShow1: "third",
        },
      });
    },
    //提交
    submit() {
      this.saveSwitch();
    },
    zhDatetime(t) {
      if (t == "" || t == null || t == undefined) {
        return "";
      } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : "0" + M;
        D = D > 9 ? D : "0" + D;
        h = h > 9 ? h : "0" + h;
        m = m > 9 ? m : "0" + m;
        s = s > 9 ? s : "0" + s;
        return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
      }
    },
    // 保存控制设备
    saveSwitch() {
      var timer = this.zhDatetime(this.formLabelAlign.pdate);
      if (this.id == undefined) {
        this.id = "";
      }
      let data = new FormData();
      data.append("code", this.formLabelAlign.code);
      data.append("addressBit", this.formLabelAlign.addressBit);
      data.append("collectTimeout", this.formLabelAlign.collectTimeout);
      data.append("gatewayId", this.formLabelAlign.gatewayId);
      data.append("intervalTime", this.formLabelAlign.intervalTime);
      data.append("pdate", timer);
      data.append("longitude", this.formLabelAlign.longitude);
      data.append("groupId", this.formLabelAlign.groupId);
      data.append("dimension", this.formLabelAlign.dimension);
      //data.append("switchType", this.formLabelAlign.switchType);
      //data.append("image", this.formLabelAlign.imageURL);

      data.append("name", this.formLabelAlign.name);
      data.append("modelRuleDeviceId", this.formLabelAlign.modelRuleDeviceId);
      data.append("id", this.id);
      data.append("protocolType", this.formLabelAlign.protocolType);
      this.$api.system
        .saveSwitch(data)
        .then((res) => {
          if (res.code == 200) {
            this.$router.push({
              name: "deviceManagement",
              query: {
                currentShow: "second",
                currentShow1: "third",
              },
            });
            this.$message({
              type: "success",
              message: res.msg,
            });
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传10张图片`);
    },

    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.srcList = [];
        this.show = true;
        this.$forceUpdate();
        this.formLabelAlign.imageURL = res.data;
        this.$toaster.ok(res.msg);

        this.imgUpdateProgress = 100;
        setTimeout(() => {
          this.isUpdateSuccess = false;
          this.imgUpdateProgress = 0;
        }, 200);
      }
    },
    handleAvatarProgress(event, file, fileList) {
      // 文件上传时的进度
      this.isUpdateSuccess = true;
      var timer = setInterval(() => {
        this.imgUpdateProgress += 10;
        if (this.imgUpdateProgress >= 90) {
          clearInterval(timer);
        }
      }, 200);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isSize = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 、PNG 格式!");
      }
      if (!isSize) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isSize;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/style/addControlManagement.scss';
img {
  display: inline-block;
  height: 100px;
  width: 100px;
  margin-right: 30px;
}
.image1 {
  margin-right: 30px;
  margin-left: 15px;
  height: 100px;
  width: 100px;
  border: 1px solid #ededed;
}
.avatar-uploader-icon {
  margin-top: 40px;
}
li {
  padding-left: 15px;
}

.isLine {
  text-align: center;
}
.inputW {
  width: 230px !important;
}
</style>